import { render, staticRenderFns } from "./RemoveOrderComponent.vue?vue&type=template&id=a6a95c10&scoped=true&"
import script from "./RemoveOrderComponent.vue?vue&type=script&lang=js&"
export * from "./RemoveOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a95c10",
  null
  
)

export default component.exports